import React from 'react'
import { DatePicker } from '@surecompanies/core_components'
import dayjs from 'dayjs'
import type { PaymentFilters } from '../Utils/types'
import {
  FilterSection,
  FilterSectionTitle,
  FilterGroup,
  FilterLabel,
} from './styles'
import type { FilterUpdateFn } from './types'

const { RangePicker } = DatePicker

interface DrawerSectionBenefitDatesProps {
  filters: PaymentFilters
  updateFilter: FilterUpdateFn
}

export default function DrawerSectionBenefitDates({
  filters,
  updateFilter,
}: DrawerSectionBenefitDatesProps) {
  return (
    <FilterSection>
      <FilterSectionTitle>Benefit Dates</FilterSectionTitle>

      <FilterGroup>
        <FilterLabel>Benefit effective date</FilterLabel>
        <RangePicker
          style={{ width: '100%' }}
          format="MM/DD/YYYY"
          value={
            filters.benefitEffectiveDateFrom && filters.benefitEffectiveDateTo
              ? [
                  dayjs(filters.benefitEffectiveDateFrom),
                  dayjs(filters.benefitEffectiveDateTo),
                ]
              : null
          }
          onChange={(dates) => {
            if (dates?.[0] && dates[1]) {
              updateFilter(
                'benefitEffectiveDateFrom',
                dates[0].format('YYYY-MM-DD')
              )
              updateFilter(
                'benefitEffectiveDateTo',
                dates[1].format('YYYY-MM-DD')
              )
            } else {
              updateFilter('benefitEffectiveDateFrom', undefined)
              updateFilter('benefitEffectiveDateTo', undefined)
            }
          }}
          allowClear
        />
      </FilterGroup>

      <FilterGroup>
        <FilterLabel>Benefit end date</FilterLabel>
        <RangePicker
          style={{ width: '100%' }}
          format="MM/DD/YYYY"
          value={
            filters.benefitEndDateFrom && filters.benefitEndDateTo
              ? [
                  dayjs(filters.benefitEndDateFrom),
                  dayjs(filters.benefitEndDateTo),
                ]
              : null
          }
          onChange={(dates) => {
            if (dates?.[0] && dates[1]) {
              updateFilter('benefitEndDateFrom', dates[0].format('YYYY-MM-DD'))
              updateFilter('benefitEndDateTo', dates[1].format('YYYY-MM-DD'))
            } else {
              updateFilter('benefitEndDateFrom', undefined)
              updateFilter('benefitEndDateTo', undefined)
            }
          }}
          allowClear
        />
      </FilterGroup>
    </FilterSection>
  )
}
